import styled from 'styled-components'

export const FullHeightContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;

  /* Ensure children can expand to full height */
  > * {
    flex: 1;
    height: 100%;
  }
`
